// let normalFacebook = require('../../images/home-new/nomal-facebook.png');
// let hoverFacebook = require('../../images/home-new/hover-facebook.png');
// let normalIns = require('../../images/home-new/nomal-ins.png');
// let hoverIns = require('../../images/home-new/hover-ins.png');
// let normalTwitter = require('../../images/home-new/nomal-twitter.png');
// let hoverTwitter = require('../../images/home-new/hover-twitter.png');
// let normalYoutube = require('../../images/home-new/nomal-youtube.png');
// let hoverYoutube = require('../../images/home-new/hover-youtube.png');
// let normalWeibo = require('../../images/home-new/nomal-weibo.png');
// let hoverWeibo = require('../../images/home-new/hover-weibo.png');
// let normalWeixin = require('../../images/home-new/nomal-weixin.png');
// let hoverWeixin = require('../../images/home-new/hover-weixin.png');
// let normalTook = require('../../images/home-new/nomal-talk.png');
// let hoverTook = require('../../images/home-new/hover-talk.png');

let imgList = {
    CN: [{
            name: 'weibo',
            path: "https://weibo.com/5893889922/profile?topnav=1&wvr=6",
            show: false
        },
        {   
            name: 'weixin',
            path: "https://mp.weixin.qq.com/",
            show: true
        }
    ],
    TW: [{
            name: 'facebook',
            path: "https://www.facebook.com/uplivecam/",
            show: false
        },
        {
            name: 'ins',
            path: "https://www.instagram.com/uplivetw/",
            show: false
        },
        {
            name: 'youtube',
            path: "https://www.youtube.com/channel/UCzF0x8cLMXgtUlsp7zmT9cQ",
            show: false
        }
    ],
    HK: [{
            name: 'facebook',
            path: "https://www.facebook.com/uplivehk/",
            show: false
        },
        {
            name: 'ins',
            path: "https://www.instagram.com/uplive_hk/",
            show: false
        },
        {
            name: 'youtube',
            path: "https://www.youtube.com/channel/UC0AUKvOH-Lpw6kEpGt3WF7g?view_as=subscriber",
            show: false
        }
    ],
    ID: [{
            name: 'facebook',
            path: "https://www.facebook.com/upliveofficial",
            show: false
        },
        {
            name: 'ins',
            path: "https://www.instagram.com/uplive.indo/",
            show: false
        },
        {
            name: 'twitter',
            path: "https://twitter.com/IndonesiaUplive?lang=zh-cn",
            show: false
        },
        {
            name: 'youtube',
            path: "https://www.youtube.com/channel/UCKZSBr80lZ5h-svP-9_VsEg",
            show: false
        }
    ],
    US: [{
            name: 'facebook',
            path: "https://www.facebook.com/uplive.usa",
            show: false
        },
        {
            name: 'ins',
            path: "https://www.instagram.com/uplive.usa/",
            show: false
        },
        {
            name: 'twitter',
            path: "https://twitter.com/UpliveUSA",
            show: false
        },
        {
            name: 'youtube',            
            path: "https://www.youtube.com/channel/UCfSiViz7kKE9Yt7LYEcj8xA",
            show: false
        }
    ],
    MSL: [{
            name: 'facebook',
            path: "https://www.facebook.com/UpliveArabApp/",
            show: false
        },
        {
            name: 'ins',
            path: "https://www.instagram.com/uplivearab/",
            show: false
        },
        {
            name: 'twitter',
            path: "https://twitter.com/Uplive_Arab",
            show: false
        },
        {
            name: 'youtube',    
            path: "https://www.youtube.com/channel/UCMrSHTXPQQT3JK1KxPgvpew/featured",
            show: false
        }
    ],
    MY: [{
            name: 'facebook',
            path: "https://www.facebook.com/UpliveMsia/",
            show: false
        },
        {
            name: 'ins',
            path: "https://www.instagram.com/uplive_msia/",
            show: false
        }
    ],
    KR: [{
            name: 'facebook',
            path: "https://www.facebook.com/Uplive.kr/",
            show: false
        },
        {
            name: 'ins',
            path: "https://www.instagram.com/uplivekr_official/",
            show: false
        },
        { //需要地址
            name: 'kakao',
            path: "https://pf.kakao.com/_bnZkxl",
            show: false
        }
    ],
    JP: [{
            name: 'facebook',
            path: "https://www.facebook.com/Asia-Innovations-Japan-%E6%A0%AA%E5%BC%8F%E4%BC%9A%E7%A4%BE-285147232081394/?modal=admin_todo_tour",
            show: false
        },
        {
            name: 'ins',
            path: "https://www.instagram.com/uplive_jp/?hl=ja",
            show: false
        },
        {
            name: 'twitter',
            path: "https://twitter.com/uplivejp?lang=ja",
            show: false
        },
        {
            name: 'youtube',
            path: "https://www.youtube.com/channel/UC9v3b0rgFQTNJN8xb6_QmZg",
            show: false
        }
    ],
    VN: [{
            name: 'facebook',
            path: "https://www.facebook.com/uplivevn/",
            show: false
        },
        {
            name: 'ins',
            path: "https://www.instagram.com/uplive.vn/",
            show: false
        },
        {
            name: 'youtube',
            path: "https://www.youtube.com/channel/UCLunRQAsZUHHGOIJ_CPt9Sg",
            show: false
        }
    ],
    IN: [{
            name: 'facebook',
            path: "https://www.facebook.com/UpliveIndia/",
            show: false
        },
        {
            name: 'ins',
            path: "https://www.instagram.com/upliveindia/",
            show: false
        },
        {
            name: 'twitter',
            path: "https://twitter.com/upliveindia",
            show: false
        }
    ]
}


export default imgList;


// WEBPACK FOOTER //
// ./js/footer/country-list.js